import { withErrorLogger } from '@move-frontend/auth';
import { cognitoClient } from '../../../../shared/api/cognito';
import { IUpdateUserAttributesData } from '../models/IUpdateUserAttributesData';
import { ICognitoUser } from '../../../../shared/api/cognito/types/ICognitoUser';
import { logError } from '../../../../shared/error/logError';

async function performUpdateUserAttributes(data: IUpdateUserAttributesData) {
	const user: ICognitoUser = await cognitoClient.getCurrentUser();

	await cognitoClient.updateUserAttributes(user, data);
}

export const updateUserAttributes = withErrorLogger(
	performUpdateUserAttributes,
	{ customLogError: logError },
);
